module.exports = __webpack_public_path__ + "img/20200114160235223.9170232a.jpg";